var appHandle = "kraken",
    isEnabled;
function initApp() {
    const t = document.querySelectorAll("form[action*='/account/login']");
    if (window.location.href.includes("account/invalid_token"))
        t.forEach((e, s) => {
            e = e.querySelector('input[name="customer[password]"');
            "none" === e.style.display && (e.style.display = "block");
        });
    else {
        const a = new XMLHttpRequest();
        (a.onreadystatechange = function () {
            var e, s;
            4 === a.readyState &&
                (200 === a.status
                    ? ((e = a.responseText),
                      (s = new URLSearchParams(window.location.search)),
                      "true" === e || 1 == s.get("_sc")
                          ? ((isEnabled = !0), releaseTheKraken())
                          : ((isEnabled = !1),
                            t.forEach((e, s) => {
                                togglePassword(e, "block");
                            })))
                    : ((isEnabled = !1),
                      t.forEach((e, s) => {
                          togglePassword(e, "block");
                      })));
        }),
            a.open("GET", "/apps/" + appHandle),
            a.send();
    }
}
function isValidEmail(e) {
    e = decodeURIComponent(e);
    return !1 !== /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi.test(e);
}
function createMessageWrapper(e, s) {
    var t = document.getElementById("messageWrapper") || null,
        t = (t && t.remove(), document.createElement("div"));
    (t.id = "messageWrapper"), e.prepend(t), t.classList.add("form-message", "note"), (t.innerHTML = s);
}
function togglePassword(e, s) {
    var t = e.querySelector('input[name="customer[password]"'),
        a = e.querySelector(".is-hidden"),
        r = e.querySelectorAll("label")[1] || null,
        e = e.querySelector(".password-wrapper");
    let o;
    (o = t ? t.parentElement.classList.contains("field") || t.parentElement.classList.contains("input") : o) ? (t.parentElement.style.display = s) : r && (r.style.display = s),
        e && (e.style.display = s),
        t && ((t.style.display = s), isEnabled) && "block" === s && t.focus(),
        a && ("block" === s && a.classList.remove("is-hidden"), "none" === s) && a.classList.add("is-hidden");
}
function releaseTheKraken() {
    document.querySelectorAll("form[action*='/account/login']").forEach((o, e) => {
        if (o) {
            var s = o.querySelector('input[name="customer[email]"');
            const n = o.querySelector("input[type=submit]") || o.querySelector("button[type=submit]") || o.querySelector("button");
            s && (s.attributes.required = "required"),
                togglePassword(o, "none"),
                (n.onclick = (e) => {
                    e.preventDefault();
                    e = new FormData(o);
                    const t = encodeURIComponent(e.get("customer[email]"));
                    e = e.get("customer[password]");
                    if (isValidEmail(t)) {
                        const a = n.value || n.innerHTML,
                            r = (n.classList.add("loading"), (n.disabled = !0), (n.value = "Please Wait"), new XMLHttpRequest());
                        (r.onreadystatechange = function () {
                            var e, s;
                            4 === r.readyState &&
                                (200 === r.status
                                    ? ((e = JSON.parse(r.responseText)),
                                      createMessageWrapper(o, e.message),
                                      (s = document.getElementById("messageWrapper")),
                                      (n.disabled = !1),
                                      n.classList.remove("loading"),
                                      (n.value = a),
                                      "enabled" === e.status || "other" === e.status
                                          ? (s.classList.remove("form-errors", "errors"), s.classList.add("form-success", "form-message--success"), window.sessionStorage.setItem("customer_email", t), togglePassword(o, "block"))
                                          : "disabled" === e.status
                                          ? (s.classList.remove("form-errors", "errors"), s.classList.add("form-success", "form-message--success"))
                                          : (s.classList.add("form-errors", "errors"), s.classList.remove("form-success", "form-message--success"), window.sessionStorage.removeItem("customer_email"), togglePassword(o, "none")))
                                    : ((n.disabled = !1), n.classList.remove("loading"), (n.value = a)));
                        }),
                            r.open("GET", `/apps/${appHandle}/customer/` + t),
                            r.send();
                    } else o.reportValidity();
                    e && o.submit();
                });
        }
    });
}
initApp();
